import { render, staticRenderFns } from "./BuyAtMarketPrice.vue?vue&type=template&id=604737a2&scoped=true&"
import script from "./BuyAtMarketPrice.vue?vue&type=script&lang=js&"
export * from "./BuyAtMarketPrice.vue?vue&type=script&lang=js&"
import style0 from "./BuyAtMarketPrice.vue?vue&type=style&index=0&id=604737a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604737a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VCheckbox,VForm,VIcon,VTextField})
